// Tested
export const checkURLPath = (path: string, url: string): boolean => {
	return path.includes(url);
};
